export const CompanyNameMinLength = 5;
export const CompanyNameMaxLength = 50;
export const FirstNameMaxLength = 50;
export const LastNameMaxLength = 50;
export const EmailMaxLength = 75;


// WEBPACK FOOTER //
// ./src/constants/signup.constants.ts